import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { getProductDepartments } from '../utils/departments';

export default function ProductCard({ produto }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    addToCart(produto);
    setAdded(true);
    setTimeout(() => setAdded(false), 1200);
  };

  const handleComprar = () => {
    addToCart(produto);
    navigate('/checkout');
  };

  return (
    <Card className="h-100 shadow-sm">
      {produto.images?.[0] && (
        <Link to={`/produto/${produto._id}`}>
          <Card.Img
            variant="top"
            src={produto.images[0]}
            alt={produto.name}
            style={{ height: '200px', objectFit: 'cover', cursor: 'pointer' }}
          />
        </Link>
      )}
      <Card.Body className="d-flex flex-column">
        <Card.Title style={{ fontSize: '1rem' }}>
          <Link to={`/produto/${produto._id}`} className="text-reset text-decoration-none">
            {produto.name}
          </Link>
        </Card.Title>
        <Card.Text className="text-muted" style={{ fontSize: '0.85rem', flexGrow: 1 }}>
          {(produto.description || '').length > 80 ? (
            <>
              {produto.description.slice(0, 80).trim()}...{' '}
              <Link to={`/produto/${produto._id}`} style={{ textDecoration: 'underline', whiteSpace: 'nowrap' }}>
                Leia mais
              </Link>
            </>
          ) : (
            produto.description
          )}
        </Card.Text>
        <div className="mt-auto">
          <p className="fw-bold mb-2" style={{ color: '#333' }}>
            R$ {produto.price?.toFixed(2).replace('.', ',')}
          </p>
          {getProductDepartments(produto).length > 0 && (
            <small className="text-muted d-block mb-2">{getProductDepartments(produto).join(' · ')}</small>
          )}
          <div className="d-grid gap-2">
            <Button variant="warning" size="sm" onClick={handleComprar}>
              Comprar
            </Button>
            <Button
              variant={added ? 'success' : 'outline-secondary'}
              size="sm"
              onClick={handleAddToCart}
            >
              {added ? 'Adicionado!' : 'Adicionar ao Carrinho'}
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
